import { CtaButton } from '@zappyrent/hundop';
import { rem, rgba } from 'polished';
import styled from 'styled-components';

export const StyledListingCard = styled.div`
  padding: ${rem('24px')};
  border-radius: ${'16px'};
  box-shadow: ${({ theme }) =>
    `0 0 ${rem('8px')} ${rgba(theme.colors.cross.silverFox, 0.5)}`};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const StyledListingCardHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${rem('16px')};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.xs}) {
    flex-direction: column;
  }
`;

export const StyledListingCardImageWrapper = styled.div`
  width: ${rem('80px')};
  height: ${rem('80px')};
  border-radius: ${rem('8px')};
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
`;

export const StyledImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  height: 100%;
  transform: translate(-50%, -50%);
`;

export const StyledListingCardmagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.cross.silverFox};
  padding: ${rem('18px')};

  & svg path {
    fill: ${({ theme }) => theme.colors.main};
  }
`;

export const StyledListingCardTitle = styled.h3`
  font-size: ${rem('16px')};
  font-weight: 700;
  margin: 0;
  margin-top: ${rem('6px')};
`;

export const StyledListingCardStatus = styled.p`
  font-size: ${rem('14px')};
  font-weight: 700;
  margin: 0;
  margin-top: ${rem('6px')};
  color: ${({ theme }) => theme.colors.landlord.main};

  display: flex;
  align-items: center;
  gap: ${rem('8px')};
`;

export const StyledListingCardBody = styled.dl`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
  gap: ${rem('16px')};
  border-radius: ${rem('8px')};
  padding: ${rem('16px')};
  margin-top: ${rem('16px')};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.s}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`;

export const StyledListingCardBodyItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem('6px')};
`;

export const StyledListingCardBodyItemTitle = styled.dt`
  font-size: ${rem('14px')};
  color: ${({ theme }) => theme.colors.cross.grayson};
`;

export const StyledListingCardBodyItemDescription = styled.dd`
  font-size: ${rem('14px')};
  color: ${({ theme }) => theme.colors.cross.black};
  font-weight: 700;
  margin: 0;
`;

export const StyledListingCardCtaButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: ${rem('16px')};
`;

export const StyledListingCardCtaButton = styled(CtaButton)`
  width: 100%;
  text-transform: uppercase;
  flex: 1 1 40%;
  min-width: ${rem('140px')};
`;
